import { message } from 'antd'
import { ProductApi } from '../../../../api/Product'
import ProductLines from '../../../../components/Main/Product/Lines/ProductLines'
import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import useSelectionTable from '../../../../elements/Hooks/useSelectionTable'
import { get } from 'lodash'
import React from 'react'

import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData from '../../../../elements/Hooks/useModalData'

function ProductLinesCont(props) {
  const { product, isUpdatable, isRemovable } = props
  const { list, fetching, fetch } = useFetchList(() => ProductApi.getLinesByProduct(product._key))

  const {
    visible,
    modalType,
    object: line,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
  } = useModalData(undefined, ProductApi.lines.update, ProductApi.lines.remove, fetch)

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await ProductApi.lines.create({
        ...newObject,
        product: { _id: product._id },
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  const { tableRef, selection, selectAll, setSelection, toggleSelection, toggleAll, isSelected } = useSelectionTable()

  const { data: formGenAll, fetching: fetchingForm } = useFetchURL(`/foxxapi/dropdowns/sku/formGen`)
  const SKUTypes = get(product, 'SKUTypes', [])
  const formGen = get(formGenAll, SKUTypes[SKUTypes.length - 1])

  return (
    <ProductLines
      {...{
        formGen,
        fetchingForm,
        list,
        fetching,
        fetch,
        visible,
        submitting,
        product,
        line,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
        isUpdatable,
        isRemovable,
        tableRef,
        selection,
        selectAll,
        setSelection,
        toggleSelection,
        toggleAll,
        isSelected,
      }}
    />
  )
}

ProductLinesCont.propTypes = {}
ProductLinesCont.defaultProps = {}

export default (ProductLinesCont)
